import { getStorage } from '~/src/common/storage';

import { HAS_SEEN_SERIES_PROMO_STORAGE_KEY } from '../storage-keys';

export function rememberHasPromoSeen() {
  const storage = getStorage();
  storage.setItem(HAS_SEEN_SERIES_PROMO_STORAGE_KEY, 'true');
}
